import { CheckCircle2 } from "lucide-react";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useCommissions } from "../data/platform-data";

export function CommissionsPage() {
  const query = useCommissions();
  return (
    <Card
      title="Comissões"
      description="Comissão é independente do split institucional e possui reversão."
      action={
        <Button>
          <CheckCircle2 size={16} /> Criar lote
        </Button>
      }
    >
      {query.isLoading && <Skeleton className="table-skeleton" />}
      {query.error && (
        <EmptyState title="Falha ao carregar comissões" description={query.error.message} />
      )}
      {!query.isLoading && !query.error && (
        <DataTable
          rows={query.data ?? []}
          getKey={(entry) => entry.id}
          columns={[
            { key: "seller", header: "Vendedor", render: (entry) => entry.seller },
            { key: "product", header: "Produto", render: (entry) => entry.product },
            { key: "sale", header: "Venda", render: (entry) => entry.sale },
            { key: "amount", header: "Valor", render: (entry) => entry.amount },
            {
              key: "status",
              header: "Status",
              render: (entry) => (
                <Badge
                  tone={entry.status === "PAID" || entry.status === "PAGA" ? "success" : "warning"}
                >
                  {entry.status}
                </Badge>
              ),
            },
          ]}
        />
      )}
    </Card>
  );
}
